import { useTranslation } from 'react-i18next';
import { Modal, StyleSheet, View } from 'react-native';

import { IndicatorScrollView } from '../../common/ScrollIndicator';
import { TouchableOpacity } from '../../common/Touchable';
import {
	RedesignCloseButton,
	redesignPanelColors,
	RedesignPanelFill,
	redesignPanelFrame,
} from '../../Modals/redesignPanelChrome';
import ProfileTournaments from '../../Profile/Tournaments/ProfileTournaments';

const PANEL_RADIUS = 16;

type TournamentStatsModalProps = {
	onClose: () => void;
	visible: boolean;
};

const TournamentStatsModal = ({ onClose, visible }: TournamentStatsModalProps) => {
	const { t } = useTranslation();

	return (
		<Modal transparent visible={visible} onRequestClose={onClose}>
			<View style={styles.tournamentStatsOverlay}>
				<TouchableOpacity activeOpacity={1} onPress={onClose} style={styles.backdropTapArea} />
				<View style={styles.tournamentStatsContainer}>
					<RedesignPanelFill radius={PANEL_RADIUS} />
					<RedesignCloseButton
						onPress={onClose}
						accessibilityLabel={t('T_SITE_CLOSE', { defaultValue: 'Close' })}
					/>
					<IndicatorScrollView
						style={styles.tournamentStatsScroll}
						contentContainerStyle={styles.tournamentStatsScrollContent}
						showsVerticalScrollIndicator
						nestedScrollEnabled
					>
						<ProfileTournaments />
					</IndicatorScrollView>
				</View>
			</View>
		</Modal>
	);
};

const styles = StyleSheet.create({
	tournamentStatsOverlay: {
		flex: 1,
		backgroundColor: redesignPanelColors.backdrop,
		justifyContent: 'center',
		alignItems: 'center',
		padding: 16,
	},
	tournamentStatsContainer: {
		...redesignPanelFrame(PANEL_RADIUS),
		width: '90%',
		maxWidth: 800,
		maxHeight: '85%',
		padding: 16,
		paddingTop: 40,
		position: 'relative',
	},
	backdropTapArea: {
		...StyleSheet.absoluteFill,
	},
	tournamentStatsScroll: {
		width: '100%',
		flexShrink: 1,
	},
	tournamentStatsScrollContent: {
		flexGrow: 1,
		paddingBottom: 16,
	},
});

export default TournamentStatsModal;
